import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const uploadExclusions = async ({ periodId, file }) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const formData = new FormData()
  formData.append('file', file)
  const { data } = await client.post(
    `/current-organization/course-assignment/periods/${periodId}/exclusions`,
    formData
  )
  return data
}

export const useUploadExclusions = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: uploadExclusions,
    hookName: 'useUploadExclusions',
    errorMessage: 'Error uploading course assignment exclusions',
    // Row-level validation errors (400 with error.errors) are expected user input mistakes,
    // shown inline by the component - only report unexpected failures.
    shouldReportError: (error) => error?.response?.status !== 400,
    onSuccess: (_data, { periodId }) => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentExclusions', periodId] })
    }
  })
}
